import { render } from "./BlockImageCarousel.vue?vue&type=template&id=33265b0c&lang=pug"
import script from "./BlockImageCarousel.vue?vue&type=script&lang=js"
export * from "./BlockImageCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__